export enum BillBundleStatus {
    Pending,
    Created,
    Released,
    Cancelled
}